module.exports = __webpack_public_path__ + "static/media/dancers-yellow.eee5c14f.png";